import CryptoJS from 'crypto-js'

function deriveKeys(token) {
  return {
    aesKey: CryptoJS.SHA256('securitycheck-aes|' + token),
    macKey: CryptoJS.SHA256('securitycheck-mac|' + token)
  }
}

function safeEqualText(left, right) {
  left = String(left || '')
  right = String(right || '')
  if (left.length !== right.length) return false
  var diff = 0
  for (var i = 0; i < left.length; i += 1) diff |= left.charCodeAt(i) ^ right.charCodeAt(i)
  return diff === 0
}

export function encryptQueryRequest(type, token, codeNum, captcha) {
  if (['code', 'pg'].indexOf(type) === -1) throw new Error('不支持的报告类型')
  if (!token) throw new Error('验证码已失效，请刷新后重试')
  var timestamp = Math.floor(Date.now() / 1000)
  var nonce = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex)
  var ivWords = CryptoJS.lib.WordArray.random(16)
  var keys = deriveKeys(token)
  var plainText = JSON.stringify({ codeNum: String(codeNum || '').trim(), captcha: String(captcha || '').trim() })
  var encrypted = CryptoJS.AES.encrypt(plainText, keys.aesKey, { iv: ivWords, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  var iv = CryptoJS.enc.Base64.stringify(ivWords)
  var ciphertext = CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
  var macText = [type, timestamp, nonce, iv, ciphertext].join('|')
  var mac = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(macText, keys.macKey))
  return { token: token, timestamp: timestamp, nonce: nonce, iv: iv, ciphertext: ciphertext, mac: mac }
}

export function decryptQueryResponse(data, token) {
  if (!data || Number(data.v) !== 1 || !data.iv || !data.ciphertext || !data.mac) throw new Error('加密响应字段不完整')
  var keys = deriveKeys(token)
  var macText = ['response', String(data.v), data.iv, data.ciphertext].join('|')
  var expectedMac = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA256(macText, keys.macKey))
  if (!safeEqualText(expectedMac, data.mac)) throw new Error('响应签名校验失败')
  var cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: CryptoJS.enc.Base64.parse(data.ciphertext) })
  var plainWords = CryptoJS.AES.decrypt(cipherParams, keys.aesKey, { iv: CryptoJS.enc.Base64.parse(data.iv), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  var plainText
  try { plainText = CryptoJS.enc.Utf8.stringify(plainWords) } catch (error) { throw new Error('响应解密失败') }
  if (!plainText) throw new Error('响应解密失败')
  try { return JSON.parse(plainText) } catch (error) { throw new Error('解密响应不是有效 JSON') }
}
